import styled from 'styled-components'
import { ChangeOwnerCard } from './ChangeOwnerCard'

export const ChangeOwnerCardUI = styled(ChangeOwnerCard)`
  margin: 1em;
`
